import { FC, useCallback, useState } from "react";
import { useBodyViewer } from "./useBodyViewer";
import ZonePanel from "./ZonePanel";
import { Intensity, ZONE_LABELS, ZoneId } from "./zones";

const Body3DTest: FC = () => {
  const [intensities, setIntensities] = useState<Partial<Record<ZoneId, Intensity>>>({});

  const handleSelectZoneFromViewer = useCallback((zoneId: ZoneId | null) => {
    // callback triggered by viewer click — no side effect needed beyond viewer state
    void zoneId;
  }, []);

  const viewer = useBodyViewer({
    intensities,
    onSelectZone: handleSelectZoneFromViewer,
  });

  const handleChangeIntensity = useCallback(
    (zoneId: ZoneId, intensity: Intensity) => {
      setIntensities((prev) => ({ ...prev, [zoneId]: intensity }));
    },
    []
  );

  const handleSelectFromPanel = useCallback(
    (zoneId: ZoneId) => {
      viewer.zoomToZone(zoneId);
    },
    [viewer]
  );

  const handleResetIntensities = useCallback(() => {
    setIntensities({});
  }, []);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        background: "linear-gradient(135deg, #1a1a22 0%, #2a2a35 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Header / status overlay */}
      <div
        style={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 10,
          padding: "12px 16px",
          background: "rgba(18, 18, 24, 0.88)",
          color: "#fff",
          borderRadius: 12,
          fontFamily: "system-ui, sans-serif",
          fontSize: 13,
          backdropFilter: "blur(14px)",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 10px 40px rgba(0,0,0,0.45)",
          minWidth: 240,
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>
          Body 3D Test · Leopart
        </div>
        <div style={{ opacity: 0.7, fontSize: 12 }}>
          {viewer.loadError
            ? `Errore: ${viewer.loadError}`
            : viewer.meshCount === null
            ? "Caricamento…"
            : `${viewer.meshCount} zone caricate`}
        </div>
        <div style={{ opacity: 0.55, fontSize: 11, marginTop: 6 }}>
          {viewer.hoveredZone
            ? `Hover: ${ZONE_LABELS[viewer.hoveredZone]}`
            : viewer.selectedZone
            ? `Selezionata: ${ZONE_LABELS[viewer.selectedZone]}`
            : "drag per ruotare · scroll per zoom"}
        </div>
      </div>

      <ZonePanel
        intensities={intensities}
        selectedZone={viewer.selectedZone}
        hoveredZone={viewer.hoveredZone}
        onChangeIntensity={handleChangeIntensity}
        onSelectZone={handleSelectFromPanel}
        onReset={handleResetIntensities}
        onResetCamera={viewer.resetCamera}
      />

      <div ref={viewer.containerRef} style={{ width: "100%", height: "100%" }} />

      {viewer.meshCount === null && !viewer.loadError && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#aab",
            fontFamily: "system-ui, sans-serif",
            pointerEvents: "none",
          }}
        >
          Caricamento modello 3D…
        </div>
      )}
    </div>
  );
};

export default Body3DTest;
